export default __webpack_public_path__ + "static/media/PLISANCI-03_unselected.3ec3c4f4.svg";